import { LatLng } from '../types'
import { ActionType, SET_CURRENT_LOCATION } from '../actions/user'

export interface UserState {
    coords?: LatLng
}

const initialState = {
}

export function userReducer(state: UserState = initialState, action: ActionType) {
    switch (action.type) {
        case SET_CURRENT_LOCATION: {
            return {
                ...state,
                coords: action.payload.coords
            }
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/user.ts